import { ConsoleRequest, DataProviderType } from './request';
import { ReadLicenseUsageDetailsResponse } from '../response';

export interface ReadLicenseUsageDetailsPayload {
  returnOnlyCount: boolean;
  unlicensedEndpointCount: boolean;
  companyId: string;
  userId: string | null;
  includeAddons: boolean | null;
}

export enum CompanyMethod {
  READ_LICENSE_USAGE_DETAILS = 'readLicenseUsageDetails',
}

const COMPANY_ENDPOINT = 'Company';

export class Company {

  public static async readLicenseUsageDetails(payload: ReadLicenseUsageDetailsPayload): Promise<ReadLicenseUsageDetailsResponse> {
    return ConsoleRequest.createRequest<ReadLicenseUsageDetailsResponse>({
      dataProviderType: DataProviderType.ENDPOINTS,
      endpoint: COMPANY_ENDPOINT,
      method: CompanyMethod.READ_LICENSE_USAGE_DETAILS,
      payload,
    });
  }
}
